import { MultiSelectResultList } from "./components/MultiSelectResultList/MultiSelectResultList.js";
import { MultiSelectSearchList } from "./components/MultiSelectSearchList/MultiSelectSearchList.js";
import styles from "./MultiSelectList.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MultiSelectList({
  titleSearchList,
  titleResultList,
  searchPlaceholder,
  onSearchChange,
  items,
  onSelectionChange,
  emptyStateTitle,
  emptyStateDescription,
  resultItemDynamicLabel,
  resultItemActions
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: styles.layout,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.section,
      children: /*#__PURE__*/_jsx(MultiSelectSearchList, {
        title: titleSearchList,
        searchLabel: searchPlaceholder,
        onSearchChange: onSearchChange,
        items: items,
        onSelectionChange: onSelectionChange
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.section,
      children: /*#__PURE__*/_jsx(MultiSelectResultList, {
        title: titleResultList,
        items: items.filter(item => item.checked),
        emptyStateTitle: emptyStateTitle,
        emptyStateDescription: emptyStateDescription,
        onRemove: itemId => onSelectionChange(items.map(item => item.id === itemId ? {
          ...item,
          checked: false
        } : item), [itemId]),
        resultItemDynamicLabel: resultItemDynamicLabel,
        resultItemActions: resultItemActions
      })
    })]
  });
}